// extracted by mini-css-extract-plugin
export default {"outer":"top-alert_outer__W+r8v","inner":"top-alert_inner__8KmSt","title":"top-alert_title__9nElw","subtitle":"top-alert_subtitle__n2AmK","close":"top-alert_close__N7DOz"};